const DAYS = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
const DAY_RE = /\b(mon|tue|wed|thu|fri|sat|sun)[a-z]*\.?/gi;
const TIME = "(\\d{1,2}(?::\\d{2})?\\s*(?:[ap]\\.?m\\.?)?|noon|midnight)";
const RANGE_RE = new RegExp(`${TIME}\\s*(?:-|–|—|to)\\s*${TIME}`, "gi");

function toMin(t, fallbackAp) {
  t = t.trim().toLowerCase();
  if (t === "noon") return 720;
  if (t === "midnight") return 1440;
  const m = t.match(/^(\d{1,2})(?::(\d{2}))?\s*([ap])?/);
  if (!m) return null;
  let h = Number(m[1]) % 12;
  const ap = m[3] || fallbackAp;
  if (ap === "p") h += 12;
  if (!ap && Number(m[1]) === 12) h = 12;
  return h * 60 + Number(m[2] || 0);
}

function daysOf(spec) {
  const s = spec.toLowerCase();
  if (/daily|every ?day|7 days|all week/.test(s)) return [0, 1, 2, 3, 4, 5, 6];
  if (/weekdays/.test(s)) return [1, 2, 3, 4, 5];
  if (/weekends?/.test(s)) return [0, 6];
  const found = [...s.matchAll(DAY_RE)].map((m) => DAYS.indexOf(m[1].slice(0, 3)));
  if (!found.length) return null;
  if (found.length === 2 && /(mon|tue|wed|thu|fri|sat|sun)[a-z]*\.?\s*(-|–|—|to|through)\s*(mon|tue|wed|thu|fri|sat|sun)/.test(s)) {
    const out = [];
    for (let d = found[0]; ; d = (d + 1) % 7) { out.push(d); if (d === found[1] || out.length > 7) break; }
    return out;
  }
  return found;
}

const ALL_DAYS = [0, 1, 2, 3, 4, 5, 6];

function rangeMinutes(m) {
  const closeAp = (m[2].match(/([ap])\.?m/i) || [])[1]?.toLowerCase();
  let open = toMin(m[1], closeAp);
  let close = toMin(m[2]);
  if (open == null || close == null) return null;
  if (!/[ap]\.?m/i.test(m[1]) && closeAp === "p" && open >= close) open -= 720;
  if (close <= open) close += 1440;
  return [open, close];
}

function segmentSpans(seg) {
  const firstTime = seg.search(/\d|noon|midnight|closed|24/i);
  const days = daysOf(firstTime > 0 ? seg.slice(0, firstTime) : "") || ALL_DAYS;
  if (/24\s*(hours|hrs|\/7)/i.test(seg)) return days.map((d) => [d, 0, 1440]);
  if (/closed/i.test(seg) && !/\d/.test(seg)) return [];
  const ranges = [...seg.matchAll(RANGE_RE)].map(rangeMinutes).filter(Boolean);
  return ranges.flatMap(([open, close]) => days.map((d) => [d, open, close]));
}

function parse(hours) {
  return (hours || "").split(/[;\n|]|,(?=\s*[a-z])/i).flatMap(segmentSpans);
}

export function openStatus(hours, now = new Date()) {
  const spans = parse(hours);
  if (!spans.length) return null;
  const d = now.getDay(), mins = now.getHours() * 60 + now.getMinutes();
  return spans.some(([day, o, c]) => (day === d && mins >= o && mins < c) || (day === (d + 6) % 7 && c > 1440 && mins < c - 1440));
}

export function hasShowTonight(item, now = new Date()) {
  const today = now.toLocaleDateString("en-CA");
  return (item.schedule || []).some((s) => s.date === today);
}
